export default __webpack_public_path__ + "static/media/bolinhas7.bea6f495.svg";